import React from "react";
import { useStore } from "../../store/store";
import { useRequiredMsgs } from "../../store/requiredMsgs";

function useSillSelector() {
  const addToQuote = useStore((state) => state.addToQuote);

  const sillColorChoice = useStore((state) => state.quote.sillColor);
  const sillStyle = useStore((state) => state.quote.sillStyle);
  const exactConfig = useStore((state) => state.quote.exactConfig);
  const material = useStore((state) => state.quote.material);

  const paintPrimeChoice = useStore((state) => state.quote.paintAndPrime);
  const primeChoice = useStore((state) => state.quote.prime);
  const stainChoice = useStore((state) => state.quote.stain);
  const customPaintChoice = useStore((state) => state.quote.customPaintOrStain);

  const findRequired = useRequiredMsgs((state) => state.findRequired);
  const removeRequired = useRequiredMsgs((state) => state.removeRequired);

  const showSillFinish =
    paintPrimeChoice || primeChoice || stainChoice || customPaintChoice
      ? true
      : false;

  const removeSillRequireds = (type: string, label: string) => {
    switch (type) {
      case "sillStyle":
        label !== "Raised Sill" &&
          removeRequired("Sill Type", "select either Rounded or Squared Sill");
        break;
      case "sillColor":
        removeRequired("Sill Finish");
        break;
      default:
        return;
    }
  };

  const handleClick = (label: string, type: string) => {
    if (!type) return;

    const checked =
      type === "sillColor"
        ? label === sillColorChoice
        : type === "sillStyle"
        ? label === sillStyle
        : "";

    if (checked) {
      addToQuote({ [type]: "" }, type);
    } else {
      addToQuote({ [type]: label });
      if (findRequired("Sill Type") || findRequired("Sill Finish"))
        removeSillRequireds(type, label);
    }
  };

  const fixedPanelSill =
    exactConfig === "Fixed Bi-fold"
      ? { img: "" }
      : exactConfig === "Fixed Inswing"
      ? { img: "/inswing", label: "Inswing Sill" }
      : exactConfig === "Fixed Outswing"
      ? { img: "/outswing", label: "Outswing Sill" }
      : exactConfig === "Fixed Full Bound" && material === "All Wood"
      ? { img: "/wood_fullbound", label: "Full Bound Sill" }
      : exactConfig === "Fixed Full Bound" && material !== "All Wood"
      ? { img: "/fullbound", label: "Full Bound Sill" }
      : { img: "/slider", label: "Raised SILLution" };

  return {
    fixedPanelSill,
    handleClick,
    showSillFinish,
    sillStyle,
    exactConfig,
    sillColorChoice,
  };
}

export default useSillSelector;
